import React, { useState, useEffect } from 'react';
import { useIntl, getLocale } from 'umi';
import { Card, Row, Col } from 'tea-component';
import { useRequest } from 'ahooks';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import Filter from '../Filter';
import { fetchCompanyDetailsSummarySummary } from '@/pages/intelligence/services/companies';
import { LANGUAGE_CN } from '@intelligence/_config/config';
import { getFormattedCardData } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overview/PerformanceSummary/cardUtils';
import type { IBaseProps, IDateTypely } from '@/pages/intelligence/types/common';
import type { ICompaniesDetailsPageBaseProps } from '../../../types';
import { COMBINEID_REG } from '@intelligence/utils/constant';
// import CardContext from '@/pages/intelligence/pages/TopCharts/components/DetailsPage/CardContext';
import OverviewCard from '@intelligence/components/OverviewCard';

const DATE_TYPES: {
  [key: string]: 'day' | 'week' | 'month';
} = {
  daily: 'day',
  weekly: 'week',
  monthly: 'month',
};
const getDateType = (dateTypely?: IDateTypely): 'day' | 'week' | 'month' => {
  if (!dateTypely) return 'day';
  return DATE_TYPES[dateTypely] ?? 'day';
};

interface IGamePerformanceSummaryProps extends IBaseProps, ICompaniesDetailsPageBaseProps {}

const GamePerformanceSummary: React.FC<IGamePerformanceSummaryProps> = (props) => {
  const { companyId, dataSources } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;

  const [fetchParams, setFetchParams] = useState<any>({
    region_type: 'region',
    regions: ['global'],
    granularity: 'monthly',
  });

  const { loading, data, run } = useRequest(fetchCompanyDetailsSummarySummary, { manual: true });
  // const metricsData = analysisSummaryRes(data);
  const cardsData = getFormattedCardData(
    data,
    'company',
    getDateType(fetchParams?.granularity),
    'sensortower',
    false,
    isCN,
  );
  const handleFilterConfirm = (payload: any) => {
    run({
      company_id: companyId,
      region_type: payload?.region_type,
      regions: payload?.regions[0] === 'GLOBAL' ? ['global'] : payload?.regions,
      granularity: payload?.granularity,
    });
    setFetchParams?.(payload);
  };

  useEffect(() => {
    if (!companyId) return;
    if (!COMBINEID_REG.test(companyId)) return; // 添加ID校验规则
    run({
      company_id: companyId,
      region_type: fetchParams?.region_type,
      regions: fetchParams?.regions,
      granularity: fetchParams?.granularity,
    });
  }, [companyId]);

  return (
    <Card>
      <Card.Body title={formatMessage({ id: 'dbi_company_game_performance_summary' })}>
        <Filter filterConfirm={handleFilterConfirm} />
        <Abnormal
          isLoading={loading}
          isNoData={false}
          component={
            <Row>
              {cardsData?.map((cardData: any, index: number) => (
                <Col span={8} key={index}>
                  {/* <CardContext */}
                  <OverviewCard
                    {...cardData}
                    dataSources={dataSources}
                    className="dbi-companies-details__card-context"
                    rankLoading={loading}
                    gameId={companyId}
                    activeId={''}
                    setActiveId={() => {}}
                    conditionMarket={{
                      regionType: fetchParams?.region_type,
                      regions: fetchParams?.regions,
                    }}
                    cardItem={cardData}
                    moduleName={'companies'}
                  />
                </Col>
              ))}
            </Row>
          }
        />
      </Card.Body>
    </Card>
  );
};

export default GamePerformanceSummary;
